import {
  buildAdebifyFilterKeySet,
  DEFAULT_ADEBIFY_AXIS,
} from 'domain/adebify/screenFilterKeys';

// Filter visibility rules for the LTVコホート分析 (Adebify LTV Cohort) screen.
//
// Source of truth: adebify/docs/要件.md §476-480 (付録E-3) and §282-291
// (要件 14-2 traffic-mode rule).
//
// Cohort filters describe the customer's first-purchase context (F1):
// - 初回購入時の広告メディア/広告グループ — gated by axis (media-sync or ebis)
// - 初回購入商品カテゴリ/初回購入商品名 — purchased-product filters
// - 初回広告対象商品カテゴリ/初回広告対象商品名 — ad-product filters
//
// At the API boundary the container remaps these keys to the cohort-specific
// f1_* parameters expected by jug-api.
const getAdebifyLtvCohortFilterKeys = (currentTab, filterContext = {}) => {
  const axis =
    filterContext.adebifyLtvCohortAxis || DEFAULT_ADEBIFY_AXIS;

  return buildAdebifyFilterKeySet({ axis, currentTab });
};

export default getAdebifyLtvCohortFilterKeys;
